"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FormField_1 = require("./FormField");
var getFieldValueFromModel_1 = require("./getFieldValueFromModel");
var JssFormData_1 = require("./JssFormData");
var ViewModel_1 = require("./ViewModel");
/**
 * Serializes a Sitecore Form data into a format ready to POST to the server.
 * @param {SitecoreForm} form The form schema data from the server
 * @param {SerializeFormOptions} [options]
 * @returns {JssFormData} form data
 */
function serializeForm(form, options) {
    if (!options) {
        options = {};
    }
    if (!options.fieldValueParser) {
        options.fieldValueParser = getFieldValueFromModel_1.getFieldValueFromModel;
    }
    var result = new JssFormData_1.JssFormData();
    pushField(result, form.formSessionId);
    pushField(result, form.antiForgeryToken);
    pushField(result, form.formItemId);
    pushField(result, form.pageItemId);
    pushFields(result, form.fields, options);
    return result;
}
exports.serializeForm = serializeForm;
/**
 * @param {JssFormData} result
 * @param {Array<FormField<any>>} fields
 * @param {SerializeFormOptions} options
 */
function pushFields(result, fields, options) {
    fields.forEach(function (field) {
        if (FormField_1.instanceOfButtonFormField(field) &&
            (!options.submitButtonName || field.buttonField.name === options.submitButtonName)) {
            pushField(result, field.buttonField, field.model.title);
            pushField(result, field.navigationButtonsField);
            pushField(result, field.navigationStepField);
        }
        else if (FormField_1.instanceOfValueFormField(field)) {
            pushField(result, field.indexField);
            pushField(result, field.fieldIdField);
            if (field.valueField.name.endsWith('.Files')) {
                var fileUploadField = field;
                if (!fileUploadField.model.files) {
                    return;
                }
            }
            // get stored value (i.e. if a multistep form)
            if (ViewModel_1.instanceOfInputViewModel(field.model) && options.fieldValueParser) {
                var fieldValue = options.fieldValueParser(field);
                if (Array.isArray(fieldValue)) {
                    fieldValue.forEach(function (value) { return pushField(result, field.valueField, value); });
                }
                else {
                    pushField(result, field.valueField, fieldValue.toString());
                }
            }
        }
        else if (FormField_1.instanceOfFormFieldSection(field)) {
            pushFields(result, field.fields, options);
        }
    });
}
/**
 * @param {JssFormData} result
 * @param {HtmlFormField} field
 * @param {string} [overrideValue]
 */
function pushField(result, field, overrideValue) {
    // the '' fallback prevents serializing 'null' as a string for empty field values ;)
    return pushFieldValue(result, field.name, overrideValue || field.value || '');
}
/**
 * @param {JssFormData} result
 * @param {string} fieldName
 * @param {string} fieldValue
 */
function pushFieldValue(result, fieldName, fieldValue) {
    if (!fieldName) {
        throw new Error('Field had no name');
    }
    result.append(fieldName, fieldValue);
}
